/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TaskCheckpointType, TaskViewVoModel } from '@well/delivery-libs/task-management/domain';
import { TranslateModule } from '@ngx-translate/core';
import { WellDatePipe } from '@well/shared-components';
import { TaskCheckpointTrackingDetailsComponent } from './task-checkpoint-tracking-details/task-checkpoint-tracking-details.component';

@Component({
    selector: 'well-task-tracking-details',
    templateUrl: './task-tracking-details.component.html',
    styleUrls: ['./task-tracking-details.component.scss'],
    imports: [TranslateModule, WellDatePipe, TaskCheckpointTrackingDetailsComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TaskTrackingDetailsComponent {
  task = input<TaskViewVoModel | undefined>();

  protected readonly TaskCheckpointType = TaskCheckpointType;
}
